import { Component, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Muro } from '../../comun/models/muro.model';
import { FuncionesService } from '../../comun/services/funciones.service';
import { MuroService } from '../../comun/services/muro.service';
import { QueryService } from '../../comun/services/query.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalConstants } from '../../global-constants';
import { forkJoin, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-muro',
  templateUrl: './muro.component.html',
  styleUrl: './muro.component.css'
})
export class MuroComponent {
  @Output() responderA = new EventEmitter<any>();
  @Output() comentarioCreado = new EventEmitter<void>();
  @ViewChild('comentarioTextarea') comentarioTextarea?: ElementRef<HTMLTextAreaElement>;
  @ViewChild('comentarioFotosInput') comentarioFotosInput?: ElementRef<HTMLInputElement>;
  fotosComentario: { archivo: File; preview: string; data: string }[] = [];
  errorComentario = '';

  async seleccionarFotosComentario(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const archivos = Array.from(input.files || []);
    input.value = '';
    this.errorComentario = '';
    if (this.fotosComentario.length + archivos.length > 5) {
      this.errorComentario = 'Puedes adjuntar un máximo de 5 fotos por comentario.';
      return;
    }
    for (const archivo of archivos) {
      if (!archivo.type.startsWith('image/')) { this.errorComentario = 'Solo se permiten archivos de imagen.'; continue; }
      if (archivo.size > 10 * 1024 * 1024) { this.errorComentario = 'Cada imagen debe ocupar menos de 10 MB.'; continue; }
      try {
        const data = await new Promise<string>((resolve, reject) => {
          const lector = new FileReader();
          lector.onload = () => resolve(String(lector.result));
          lector.onerror = () => reject(new Error('No se pudo leer la imagen'));
          lector.readAsDataURL(archivo);
        });
        this.fotosComentario.push({ archivo, preview: data, data });
      } catch { this.errorComentario = 'No se pudo leer alguna de las imágenes.'; }
    }
  }
  quitarFotoComentario(i: number): void { this.fotosComentario.splice(i, 1); }

  respondiendoA: any = null;
  modalComentarios = false;
  @HostListener('document:keydown.escape') onEscape(): void {
    if (this.modalComentarios) this.cerrarComentarios();
  }
  ngOnDestroy(): void { if (this.modalComentarios) document.body.style.overflow = ''; }
  solicitarResponder(publicacion: any): void {
    if (this.muro.nivel === 0) {
      this.abrirComentarios();
      this.seleccionarRespuesta(publicacion.rs_id === this.muro.rs_id ? null : publicacion);
    } else {
      this.responderA.emit(publicacion);
    }
  }
  seleccionarRespuesta(publicacion: any): void {
    this.respondiendoA = publicacion;
    // Safari en iOS solo abre el teclado si focus() se ejecuta directamente
    // durante el gesto del usuario, sin setTimeout ni requestAnimationFrame.
    // Al abrir simplemente la conversación no se enfoca el textarea.
    if (!publicacion || !this.modalComentarios) return;
    const campo = this.comentarioTextarea?.nativeElement;
    if (campo && !campo.disabled) {
      try { campo.focus({ preventScroll: true }); }
      catch { campo.focus(); }
      // No usar scrollIntoView con animación: puede interferir con el teclado iOS.
    }
  }
  propagarRespuesta(publicacion: any): void {
    if (this.muro.nivel === 0) {
      this.abrirComentarios();
      this.seleccionarRespuesta(publicacion);
    } else {
      this.responderA.emit(publicacion);
    }
  }
  cancelarRespuesta(): void { this.respondiendoA = null; }

  fotoActual = 0;
  nuevoComentario = '';
  enviandoComentario = false;

  abrirComentarios() {
    this.modalComentarios = true;
    this.fotoActual = 0;
    document.body.style.overflow = 'hidden';
  }
  cerrarComentarios() {
    this.modalComentarios = false;
    this.respondiendoA = null;
    document.body.style.overflow = '';
  }
  cambiarFoto(direccion: number) { const n = this.muro.rs_fotos?.length || 0; if (n) this.fotoActual = (this.fotoActual + direccion + n) % n; }
  publicarComentario() {
    const texto = this.nuevoComentario.trim();
    if ((!texto && !this.fotosComentario.length) || this.enviandoComentario) return;
    this.errorComentario = '';
    if (!this.misdatos?.ID) { window.location.href = '/login'; return; }
    this.enviandoComentario = true;
    const datos: any = {
      rs_id: 0, rs_parent_id: this.respondiendoA?.rs_id || this.muro.rs_id, rs_tipo_publicacion: '',
      rs_tipo: this.muro.rs_tipo, rs_tipo_id: this.muro.rs_tipo_id, rs_ma_id: 0,
      rs_texto: texto, rs_alcance: this.muro.rs_alcance, ubicacion: false
    };
    this.query.query('muros', 'PUBLICAR', datos).pipe(
      switchMap((r: any) => {
        if (r?.resultado !== 'OK' || !r?.id) {
          throw new Error(r?.mensaje || 'No se pudo publicar el comentario.');
        }
        if (!this.fotosComentario.length) return of(r);
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        const subidas = this.fotosComentario.map((foto) => {
          const formData = new FormData();
          formData.append('data', foto.data);
          formData.append('principal', '');
          formData.append('tipo', this.muro.rs_tipo);
          formData.append('tipo_id', String(r.id));
          return this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers });
        });
        return forkJoin(subidas);
      })
    ).subscribe({
      next: () => {
        this.enviandoComentario = false;
        this.nuevoComentario = '';
        this.fotosComentario = [];
        this.respondiendoA = null;
        this.comentarioCreado.emit();
        this.query.query('muros', 'MAS_COMENTARIOS', {
          rs_id: this.muro.rs_id, tipo: this.muro.rs_tipo, tipo_id: this.muro.rs_tipo_id,
          tipo_publicacion: '', page: 1, limit: 10, nivel: 0
        }).subscribe((items: any) => {
          if (!Array.isArray(items)) return;
          this.muro.comentarios = items;
          this.muro.totalcomentarios = Math.max(Number(this.muro.totalcomentarios || 0) + 1, items.length);
          this.muro.numcomentarios = Math.max(0, Number(this.muro.totalcomentarios) - items.length);
          this.muro.page = 2;
          this.muro.noMasComentarios = this.muro.numcomentarios === 0;
        });
      },
      error: (err: any) => {
        this.enviandoComentario = false;
        this.errorComentario = err?.message || 'No se pudo completar el envío. Comprueba si el comentario se ha publicado antes de reintentar.';
      }
    });
  }

  @Input() misdatos!: any;
  @Input() perfil!: any;
  @Input() muro!: Muro;

  constructor(private funcionesService: FuncionesService, private muroService: MuroService, private query: QueryService, private http: HttpClient) { }

  ngOnInit() {
    this.funcionesService.initMuro(this.muro);
  }

  getCarouselImages(comentario: any): { thumb: string; full: string }[] {
    // Caso base: si no hay comentario, rs_fotos no existe o está vacío
    if (!comentario?.rs_fotos?.length) {
      return [];
    }

    return comentario.rs_fotos.map((foto: any) => ({
      thumb: foto.foto_thumb || '',   // miniatura
      full: foto.foto_grande || '',    // imagen grande usada en el carousel
      id: foto.ft_id || 0
    }));
  }

  masComentarios() {
    if (this.muro.loadingComentarios || this.muro.noMasComentarios) return;
    const limite = 2;
    const pagina = Math.max(1, Number(this.muro.page || 2));
    this.muro.loadingComentarios = true;
    this.query.query('muros', 'MAS_COMENTARIOS', {
      rs_id: this.muro.rs_id,
      tipo: this.muro.rs_tipo,
      tipo_id: this.muro.rs_tipo_id,
      page: pagina, limit: limite, nivel: this.muro.nivel
    }).subscribe({
      next: (resultado: any) => {
        this.muro.loadingComentarios = false;
        if (!Array.isArray(resultado)) {
          this.muro.noMasComentarios = true;
          this.muro.numcomentarios = 0;
          return;
        }
        const actuales = new Set((this.muro.comentarios || []).map((c: any) => Number(c.rs_id)));
        const nuevos = resultado.filter((c: any) => !actuales.has(Number(c.rs_id)));
        if (!Array.isArray(this.muro.comentarios)) this.muro.comentarios = [];
        // Evitar duplicar respuestas si se carga la misma página más de una vez.
        for (const comentario of nuevos) this.muro.comentarios.push(comentario);
        this.muro.page = pagina + 1;
        const total = Number(this.muro.totalcomentarios || 0);
        this.muro.numcomentarios = Math.max(0, total - this.muro.comentarios.length);
        if (resultado.length < limite || this.muro.numcomentarios === 0 || nuevos.length === 0) {
          this.muro.noMasComentarios = true;
          if (resultado.length === 0 || nuevos.length === 0) this.muro.numcomentarios = 0;
        }
      },
      error: () => { this.muro.loadingComentarios = false; }
    });
  }

  respondeEncuesta(pregunta: any, respuesta: any) {
    pregunta.busy = true;
    this.query.query('muros', 'RESPONDERENCUESTA', { pregunta: pregunta, respuesta: respuesta }).subscribe((resultado:any) => {
      this.query.query('muros', 'RED', { ID: 0, rs_id: this.muro.rs_id, tipo: this.muro.rs_tipo, tipo_id: this.muro.rs_tipo_id, rs_ma_id: this.muro.rs_ma_id, page: this.muro.page, limit: 2 }).subscribe((resultado:any) => {
        this.muro = resultado[0];
        this.muroService.actualizar(this.muro);
        pregunta.busy = false;
      });
    });
  }

  getRespuestaTexto(pregunta: any, i: number): string | null {
    const texto = (pregunta as any)[`rse_respuesta_${i}`];
    return texto && texto.trim() !== '' ? texto : null;
  }

  getPorcentaje(pregunta: any, textoRespuesta: string): number {
    const respuesta = pregunta.respuestas?.find((r: any) => r.respuesta === textoRespuesta);
    return respuesta ? respuesta.porcentaje : 0;
  }

}
